import { Row, Space } from 'antd';
import React, { CSSProperties, ReactNode } from 'react';

export interface RealTimeTitleBlockPropies {
    children?: ReactNode;
    style?: CSSProperties;
    title?: string;
    titleComponent?: ReactNode;
}

export default function RealTimeTitleBlock(props: RealTimeTitleBlockPropies) {
    return <div style={props.style}>
        <Row>
            <Space>
                <div style={{
                    width: 5,
                    height: 18,
                    backgroundColor: '#2755bd',
                    margin: 0,
                }} />
                <span style={{
                    fontSize: 18,
                    fontWeight: 'bolder',
                    color: '#2755bd',
                }}>
                    {props.title}
                </span>
                {props.titleComponent}
            </Space>
        </Row>
        <Row style={{ height: 20 }} />
        <Row style={{
            border: '1px solid #dcdfe5',
            padding: 20,
            width: '100%',
        }}>
            {props.children}
        </Row>
    </div>
}
